import React from "react";
import { Link, useNavigate } from "react-router-dom";

const UserDropdownContent = ({ data, role }) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userId");
    navigate("/");
  };
  return (
    <div className="p-2">
      {/* <div className="text-sm text-gray-900 font-medium">{data.email}</div>
      <div className="text-xs text-gray-500 mb-2">{role}</div> */}
      <hr className="mt-0 mb-3 bg-slate-500 h-0.5" />
      <ul className="text-sm space-y-1">
        <li className="cursor-pointer flex list-none items-center overflow-hidden whitespace-nowrap">
            <Link className="mb-1 p-2 flex gap-2 items-center cursor-pointer overflow-hidden rounded-xl border hover:text-zinc-950 dark:hover:text-slate-900 grow transition-all duration-300 ease-in-out border-zinc-300 text-zinc-500 dark:border-zinc-800 dark:text-slate-700 max-md:hidden">
            <div><i class="fa-regular fa-user"></i></div>
            <div>Profile</div>
            </Link>
        </li>
        {/* <li className="cursor-pointer flex list-none items-center overflow-hidden whitespace-nowrap">
            <Link className="mb-1 p-2 flex gap-2 items-center cursor-pointer overflow-hidden rounded-xl hover:text-zinc-950 dark:hover:text-slate-900 grow transition-all duration-300 ease-in-out text-zinc-500 dark:text-slate-700 max-md:hidden justify-between">
            <div className="flex items-center gap-2">
                <span><i class="fa-regular fa-envelope"></i></span>
                <div>Inbox</div>
            </div>
            <div className="flex items-center gap-3">
                <span className="bg-blue-700 text-white py-1 px-2 rounded-md leading-none">3</span>
                <Link className="border border-zinc-950 rounded-full w-5 aspect-square flex justify-center items-center leading-none"><i class="fa-regular fa-plus"></i></Link>
            </div>
            </Link>
        </li> */}
        {/* <li onClick={handleLogout} className="cursor-pointer flex list-none items-center overflow-hidden whitespace-nowrap">
            <Link className="mb-1 p-2 flex gap-2 items-center cursor-pointer overflow-hidden rounded-xl hover:text-zinc-950 dark:hover:text-slate-900 grow transition-all duration-300 ease-in-out text-slate-700 dark:text-slate-700 max-md:hidden">
            <div><i class="fa-regular fa-right-from-bracket"></i></div>
            <div>Log Out</div>
            </Link>
        </li> */}

        <li className="cursor-pointer flex list-none items-center overflow-hidden whitespace-nowrap">
  <button
    onClick={handleLogout}
    className="w-full text-left mb-1 p-2 flex gap-2 items-center cursor-pointer overflow-hidden rounded-xl hover:text-zinc-950 dark:hover:text-slate-900 grow transition-all duration-300 ease-in-out text-slate-700 dark:text-slate-700 max-md:hidden"
  >
    <div><i className="fa-regular fa-right-from-bracket"></i></div>
    <div>Log Out</div>
  </button>
</li>
      </ul>
    </div>
  );
};

export default UserDropdownContent;
